// Import Assets
import CommingSoonIllustration from '../../assets/Illustrations/Mascot/CommingSoon_Illustration.jpg';
import ContactIllustration from '../../assets/Illustrations/Mascot/Contact_Illustration.jpg';

export const commingSoonIllustration = CommingSoonIllustration;
export const contactIllustration = ContactIllustration;
